import { makeAutoObservable } from 'mobx';
import apiConfig from '../api/routes';

class Support{
  constructor() {
    makeAutoObservable(this);
  }

  sendFeedback = async (formData: FormData) => {
    return apiConfig.supportService.submitFeedback(formData);
  };
}


export const SupportStore = new Support();
